import {changeIssuesTabCounter} from '@github-ui/issues-tab-counter'
import {commitMutation, graphql} from 'react-relay'
import type {Environment, RecordSourceSelectorProxy} from 'relay-runtime'

import type {
  IssueClosedStateReason,
  IssueState,
  updateIssuesBulkActionsMutation,
  UpdateIssuesBulkInput,
} from './__generated__/updateIssuesBulkActionsMutation.graphql'

type issueUpdateArgs = {
  state: IssueState
  stateReason?: IssueClosedStateReason
}

export function updateIssuesById(store: RecordSourceSelectorProxy, ids: string[], issueUpdateArgs: issueUpdateArgs) {
  for (const id of ids) {
    const issue = store.get(id)
    if (issue) {
      for (const [key, value] of Object.entries(issueUpdateArgs)) {
        issue.setValue(value, key)
      }
    }
  }
}

export function commitUpdateIssueBulkMutation({
  environment,
  optimisticUpdateIds,
  input: {ids, state, stateReason},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {ids: string[]} & issueUpdateArgs
  optimisticUpdateIds: string[]
  onCompleted?: (response: updateIssuesBulkActionsMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {state, stateReason}
  const inputHash: UpdateIssuesBulkInput = {
    ids,
    ...inputArgs,
  }

  let tabCounterDelta = 0

  return commitMutation<updateIssuesBulkActionsMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation updateIssuesBulkActionsMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    updater: store => updateIssuesById(store, optimisticUpdateIds, inputArgs),
    optimisticUpdater: store => {
      for (const id of optimisticUpdateIds) {
        const issue = store.get(id)
        if (issue) {
          const currentState = issue.getValue('state')
          if (currentState === 'OPEN' && state === 'CLOSED') tabCounterDelta--
          else if (currentState === 'CLOSED' && state === 'OPEN') tabCounterDelta++
        }
      }
      updateIssuesById(store, optimisticUpdateIds, inputArgs)
      if (tabCounterDelta !== 0) changeIssuesTabCounter(tabCounterDelta)
    },
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => {
      if (tabCounterDelta !== 0) changeIssuesTabCounter(-tabCounterDelta)
      if (onError) onError(error)
    },
  })
}
